module.exports = __webpack_public_path__ + "img/zhongzhimima.c88e8402.png";